import Vue from "vue";
import Router from "vue-router";
import posLogin from "@/components/posLogin";
import PosBooking from "@/components/posBooking";

Vue.use(Router);

const router = new Router({
  mode: "hash",
  routes: [
    {
      path: "/",
      name: "posLogin",
      component: () => import("@/components/posLogin"),
    },
    {
      path: "/pos-cash-input",
      name: "Pos Cash Input",
      component: () => import("@/components/posCashInput"),
    },
    {
      path: "/pos-booking",
      name: "PosBooking",
      component: () => import("@/components/posBooking.vue"),
    },
    {
      path: "/pos-fnb",
      name: "PosFnb",
      component: () => import("@/components/posFnb.vue"),
    },
    {
      path: "/pos-games",
      name: "PosGames",
      component: () => import("@/components/posFnb.vue"),
      meta: { posSection: "GAMES" },
    },
    {
      path: "/pos-fnb/:reservation_id",
      name: "PosBoFnb",
      component: () => import("@/components/posFnb.vue"),
    },
    {
      path: "/pos-fnb/:type_id/:reservation_id",
      name: "PosFnbBack",
      component: () => import("@/components/posFnb.vue"),
    },
    {
      path: "/pos-seatlayout/:ss_id/:md_id/:screen_id",
      name: "PosSeatLayout",
      component: () => import("@/components/posSeatLayout.vue"),
    },
    {
      path: "/pos-checkout/:type_id/:reservation_id",
      name: "PosSeatLayout",
      component: () => import("@/components/posCheckout.vue"),
    },
    {
      path: "/pos-final-ticket/:type_id/:booking_code",
      name: "PosFinalTicket",
      component: () => import("@/components/PosFinalTicket.vue"),
    },
    {
      path: "/pos-refund",
      name: "PosRefund",
      component: () => import("@/components/posRefund.vue"),
    },
    {
      path: "/fnb-settings",
      name: "PosFnbSettings",
      component: () => import("@/components/fnbCategorySettings.vue"),
    },
    {
      path: "/fnb-refund",
      name: "FnbRefund",
      component: () => import("@/components/fnbRefund.vue"),
    },
    {
      path: "/pos-user-transactions",
      name: "PosUserTransactions",
      component: () => import("@/components/posUserTransaction.vue"),
    },
    {
      path: "/screen-schedules",
      name: "PosScreenScedulingReport",
      component: () => import("@/components/PosScreenScedulingReport.vue"),
    },
    {
      path: "/online-fnb-orders",
      name: "PosOnlineFnbOrders",
      component: () => import("@/components/posOnlineFnbOrders.vue"),
    },
    {
      path: "/consumable-raw-material-list",
      name: "PosRawMaterialConsumable",
      component: () => import("@/components/PosRawMaterialConsumable.vue"),
    },
    {
      path: "/pos-user-fnb-transactions",
      name: "PosUserTransactions",
      component: () => import("@/components/posUserFnbTransaction.vue"),
    },
    {
      path: "/pos-user-collection",
      name: "posUserCollection",
      component: () => import("@/components/posUserCollection.vue"),
    },
    {
      path: "/cash-card",
      name: "cashCard",
      component: () => import("@/components/CashCardPos.vue"),
    },
    {
      path: "/cash-card-topup",
      name: "cashCardTopup",
      component: () => import("@/components/CashCardCheckout.vue"),
    },
    {
      path: "/cash-card-topup-details/:topup_code",
      name: "cashCardFinalPage",
      component: () => import("@/components/CashCardFinalPage.vue"),
    },
    {
      path: "/e-wallet",
      name: "eWalletRecharge",
      component: () => import("@/components/EwalletRecharge.vue"),
    },
    {
      path: "/e-wallet-checkout",
      name: "eWalletCheckout",
      component: () => import("@/components/EwalletCheckout.vue"),
    },
    {
      path: "/e-wallet-topup-details/:topup_code",
      name: "eWalletFinalPage",
      component: () => import("@/components/EwalletFinalPage.vue"),
    },
    {
      path: "/movie-pass",
      name: "moviePass",
      component: () => import("@/components/MoviePassPage.vue"),
    },
    {
      path: "/movie-pass-checkout/:reservation_id",
      name: "moviePassCheckout",
      component: () => import("@/components/MoviePassCheckout.vue"),
    },
    {
      path: "/movie-pass-final/:trx_code",
      name: "moviePassFinalPage",
      component: () => import("@/components/MoviePassFinalPage.vue"),
    },
    {
      path: "/merchandise",
      name: "merchandise",
      component: () => import("@/components/MerchandisePage.vue"),
    },
    {
      path: "/merchandise-checkout/:reservation_id/:key_id",
      name: "merchandiseCheckout",
      component: () => import("@/components/MerchandiseCheckout.vue"),
    },
    {
      path: "/merchandise-final/:trx_code/:trx_id",
      name: "merchandiseFinalPage",
      component: () => import("@/components/MerchandiseFinalPage.vue"),
    },
    {
      path: "/pos-occupancy",
      name: "posSchedule",
      component: () => import("@/components/posSchedule.vue"),
    },
    {
      path: "/show-transactions/:ss_id",
      name: "showTransactions",
      component: () => import("@/components/scheduleWiseTransactions.vue"),
    },
    {
      path: "/unpaid-bookings",
      name: "unpaidBookings",
      component: () => import("@/components/unpaidBooking.vue"),
    },
    {
      path: "/pay-at-counter",
      name: "Pay At Counter",
      component: () => import("@/components/payAtCounter.vue"),
    },
    {
      path: "/pos-fnb-pickup",
      name: "posPickupFnB",
      component: () => import("@/components/posPickupFnB.vue"),
    },
    {
      path: "/pos-ticket-pickup",
      name: "posPickUpTickets",
      component: () => import("@/components/posPickUpTickets.vue"),
    },
    {
      path: "/kitchen-sales",
      name: "kitchenDisplay",
      component: () => import("@/components/kitchenDisplay.vue"),
    },
    {
      path: "/kitchen-pickup",
      name: "kitchenDisplayDelivery",
      component: () => import("@/components/kitchenDisplayDelivery.vue"),
    },
    {
      path: "/kitchen-customer-display/:type/:kitchen_id/:cinema_id", //type for 2 premier or 1 normal,
      name: "kitchenCustomerDelivery",
      component: () => import("@/components/kitchenCustomerTvDelivery.vue"),
    },
    {
      path: "/nuvio-kitchen-customer-display-v2/:type/:kitchen_id/:cinema_id",
      name: "kitchenCustomerDelivery",
      component: () => import("@/components/kitchenNovoTvDeliveryDisplay.vue"),
    },
    {
      path: "/customer-loyalty",
      name: "CustomerLoyalty",
      component: () => import("@/components/CustomerLoyalty.vue"),
    },
  ],

  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0,
    };
  },
});

router.beforeEach((to, from, next) => {
  console.log("to", to);
  console.log("from", from);
  console.log("check path", to.path.includes("/kitchen-customer-display/"));

  if (to.path.includes("/kitchen-customer-display/")) {
    return next();
  }
  if (to.path.includes("/nuvio-kitchen-customer-display-v2/")) {
    return next();
  }

  let user_access_token = localStorage.getItem("JWT_TOKEN");
  let accessLimitation = window.localStorage.getItem("USER_ROLE_NAME");
  let isFloatAmountAdded = window.localStorage.getItem("FLOAT_AMOUNT_ADDED")
    ? window.localStorage.getItem("FLOAT_AMOUNT_ADDED") == "Y"
    : false;

  if (
    from.path == "/kitchen-sales" &&
    to.path != "/kitchen-sales" &&
    (accessLimitation == "PICKUPKITCHEN" || accessLimitation == "KITCHENUSER")
  ) {
    return next({
      path: "/kitchen-sales",
    });
  } else if (
    from.path == "/kitchen-pickup" &&
    to.path != "/kitchen-sales" &&
    (accessLimitation == "PICKUPKITCHEN" || accessLimitation == "KITCHENUSER")
  ) {
    return next({
      path: "/kitchen-pickup",
    });
  }

  if (!user_access_token && !isFloatAmountAdded) {
    if (to.path != "/" && !to.path.includes("/kitchen-customer-display/")) {
      return next({
        path: "/",
      });
    }
    if (
      to.path != "/" &&
      !to.path.includes("/nuvio-kitchen-customer-display-v2/")
    ) {
      return next({
        path: "/",
      });
    }
  } else if (user_access_token && !isFloatAmountAdded) {
    if (
      to.path != "/pos-cash-input" &&
      to.path != "/kitchen-pickup" &&
      to.path != "/kitchen-sales"
    ) {
      let nextRoute = "POS_LOGIN";
      if (accessLimitation) {
        if (accessLimitation == "FNBONLY") {
          nextRoute = "FNB_LOGIN";
        }
      }
      return next({
        path: "/pos-cash-input",
        query: { nextRoute: nextRoute },
      });
    }
  } else if (user_access_token && isFloatAmountAdded) {
    if (
      to.path == "/" ||
      (to.path == "/pos-cash-input" && isFloatAmountAdded)
    ) {
      if (window.localStorage.getItem("USER_ROLE_NAME")) {
        if (accessLimitation == "FNBONLY") {
          return next({
            path: "/pos-fnb",
          });
        } else {
          return next({
            path: "/pos-booking",
          });
        }
      } else {
        return next({
          path: "/pos-booking",
        });
      }
    }
  }
  return next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js